<template>
  <div>
    <a-card :tab-list="tabList" :active-tab-key="currentTab" @tabChange="tabChange">
      <div v-if="currentTab == 'offlineSalesOrder'">
        <offline-sales-order></offline-sales-order>
      </div>
      <div v-else-if="currentTab == 'inlineSalesOrder'">
        <inline-sales-order></inline-sales-order>
      </div>
    </a-card>
  </div>
</template>

<script>
  export default {
    components: {
      offlineSalesOrder: () => import('./offlineSalesOrder'),
      inlineSalesOrder: () => import('./inlineSalesOrder'),
    },
    data() {
      return {
        tabList: [
          {
            key: 'offlineSalesOrder',
            tab: '线下订单',
          },
          {
            key: 'inlineSalesOrder',
            tab: '线上订单',
          },
        ],
        currentTab: undefined,
      }
    },
    methods: {
      initData() {
        let currentTab = this.$route.query.currentTab;
        if (currentTab) {
          this.currentTab = currentTab;
        } else {
          this.currentTab = this.tabList[0].key;
          this.$router.push({ query: { currentTab: this.currentTab } });
        }
      },
      tabChange(key) {
        this.currentTab = key;
        this.$router.push({ query: { currentTab: this.currentTab } });
      },
    },
    mounted() {
      this.initData();
    },
  }
</script>